import { render, staticRenderFns } from "./Exception04.vue?vue&type=template&id=70d9132b&scoped=true"
import script from "./Exception04.vue?vue&type=script&lang=js"
export * from "./Exception04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9132b",
  null
  
)

export default component.exports